'use client'

import { useState, useContext, useEffect } from 'react'
import { Button } from '@/components/ui/shadcn/button'
import { Label } from '@/components/ui/shadcn/label'
import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/shadcn/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/shadcn/select'
import { fetcher } from '@/lib/api/fetch'
import { AuthContext } from '@/contexts/AuthContext'
import { ManagerContext } from '@/contexts/ManagerContext'
import ErrorAlerts from '@/components/common/feedback/ErrorAlerts'

export default function ChooseOrganization({ setOpen, changePage }) {
  const authContext = useContext(AuthContext)
  const context = useContext(ManagerContext)
  const [chosen, setChosen] = useState(null)
  const [error, setError] = useState(null)
  const [errors, setErrors] = useState(null)
  const [loading, setLoading] = useState(false)

  const choose = async e => {
    e.preventDefault()

    if (!chosen) {
      setError('Please select an organization.')
      return
    }

    setLoading(true)

    const res = await fetcher(
      '/api/admin/user/' + authContext.user.id,
      {
        method: 'POST',
        body: JSON.stringify({ organization: chosen }),
      },
      authContext,
    )

    const data = await res.json()
    setLoading(false)

    if (res.ok) {
      setError(null)

      authContext.setuser(
        {
          ...authContext.user,
          organization: context.organizations.find(o => o.id === chosen),
        },
        () => {
          setOpen(false)
          window.location.replace('/manager/dashboard')
        },
      )
    } else if (data.message) setError(data.message)
    else setErrors(data.messages)
  }

  useEffect(() => {
    if (authContext.user.organization?.id) {
      setChosen(authContext.user.organization.id)
    }
  }, [authContext.user])

  return (
    <form onSubmit={choose} className="flex flex-col gap-4">
      <DialogHeader>
        <DialogTitle>Choose an organization</DialogTitle>
        <DialogDescription>
          Select the organization you want to manage.
        </DialogDescription>
      </DialogHeader>

      <ErrorAlerts
        error={error}
        errors={errors}
        message="There is an issue with your submission:"
      />

      <div className="space-y-2">
        <Label htmlFor="choose-organization">Organization</Label>
        <Select value={chosen || ''} onValueChange={setChosen}>
          <SelectTrigger id="choose-organization" className="w-full">
            <SelectValue placeholder="Select an organization" />
          </SelectTrigger>
          <SelectContent>
            {context.organizations.map(org => (
              <SelectItem key={org.id} value={org.id}>
                {org.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <DialogFooter>
        {authContext.user.isAdmin && (
          <Button
            type="button"
            variant="outline"
            onClick={() => changePage('create')}
          >
            Create new organization
          </Button>
        )}
        <Button type="submit" disabled={loading || !chosen}>
          {loading ? 'Choosing...' : 'Choose organization'}
        </Button>
      </DialogFooter>
    </form>
  )
}
